import { createSlice } from '@reduxjs/toolkit';
import { fetchAlbum, updateAlbum, uploadCoverPhoto } from '../thunks/album';
import { createAlbum } from '../thunks/albums';

const initialState = {
  album: {},
  albumId: null,
  nameBeforeUpdate: '',
  noSpaceAlertMessage: '',
  restrictionAndS3failedPhotos: [],
  s3UploadFailedPhotos: [],
  showUploadLoader: false,
  successMessage: false,
  isCoverPhotoUploading: false,
  isAlbumNameEditing: false,
  fetching: false,
  fetchError: '',
  saving: false,
  saveError: '',
};

export const albumSlice = createSlice({
  name: 'album',
  initialState,
  reducers: {
    updateAlbumData: (state, action) => {
      state.album = { ...state.album, ...action.payload };
    },
    setAlbumNameEditing: (state) => {
      state.isAlbumNameEditing = true;
    },
    resetAlbumNameEditing: (state) => {
      state.isAlbumNameEditing = false;
      state.album.name = state.nameBeforeUpdate;
    },
    setCoverPhotoUploading: (state, action) => {
      state.isCoverPhotoUploading = action.payload;
    },
    setNoSpaceAlertMessage: (state, action) => {
      state.noSpaceAlertMessage = action.payload;
    },
    setConsolidatedMessage: (state, action) => {
      const { restrictionFailedFiles, s3UploadFailedFiles } = action.payload;

      state.restrictionAndS3failedPhotos = [
        ...restrictionFailedFiles,
        ...s3UploadFailedFiles,
      ];
      state.s3UploadFailedPhotos = s3UploadFailedFiles;
    },
    showSuccessMessage: (state, action) => {
      state.successMessage = action.payload;
    },
    setAlbumId: (state, action) => {
      state.albumId = action.payload;
    },
  },
  extraReducers: {
    [fetchAlbum.pending]: (state) => {
      state.fetching = true;
    },
    [fetchAlbum.fulfilled]: (state, action) => {
      state.fetching = false;
      state.album = action.payload;
      state.nameBeforeUpdate = action.payload.name;
    },
    [fetchAlbum.rejected]: (state, action) => {
      state.fetching = false;
      state.fetchError = action.payload.error;
    },
    [updateAlbum.pending]: (state) => {
      state.saving = true;
    },
    [updateAlbum.fulfilled]: (state) => {
      state.saving = false;
      state.isAlbumNameEditing = false;
      state.nameBeforeUpdate = state.album.name;
    },
    [updateAlbum.rejected]: (state, action) => {
      state.saving = false;
      state.saveError = action.payload.error;
      state.isAlbumNameEditing = false;
    },
    [uploadCoverPhoto.pending]: (state) => {
      state.saving = true;
    },
    [uploadCoverPhoto.fulfilled]: (state, action) => {
      state.saving = false;
      state.album = { ...state.album, ...action.payload };
    },
    [uploadCoverPhoto.rejected]: (state, action) => {
      state.saving = false;
      state.saveError = action.payload.error;
    },
    [createAlbum.fulfilled]: (state, action) => {
      state.saving = false;
      state.album = action.payload;
    },
  },
});

export const {
  setCoverPhotoUploading,
  updateAlbumData,
  setAlbumNameEditing,
  resetAlbumNameEditing,
  setNoSpaceAlertMessage,
  setConsolidatedMessage,
  showSuccessMessage,
  setAlbumId,
} = albumSlice.actions;
